<template>
  <div v-if="TodayKatamars.length > 0 || TodaySinksar.length > 0">
    <div class="product-wrapper shop-list load-more-contain section-gap">
      <div class="row justify-content-between">
        <div class="card col-md-6" v-if="TodaySinksar.length > 0">
          <div class="feature-slide-content p-3 card-body">
            <h2 class="mb-4">{{ $t("Sinksar") }}</h2>

            <ul class="list-unstyled mb-0">
              <li
                class="text-muted mb-3"
                v-for="(item, index) of TodaySinksar.slice(0, 3)"
                :key="index"
              >
                <!-- <i :class="feature.icon" class="mr-3"></i> -->
                # {{ item.Name }}
              </li>
            </ul>
            <div class="col-12 mt-3">
              <button
                @click="GetDetails"
                class="rounded-pill text-white btn btn-primary"
              >
                {{ $t("ViewMore") }}
              </button>
            </div>
          </div>
        </div>

        <div class="card col-md-6" v-if="TodayKatamars.length > 0">
          <div class="feature-slide-content p-10 card-body">
            <h2 class="mb-4">{{ $t("Katamars") }}</h2>

            <ul class="list-unstyled mb-0">
              <li
                class="text-muted mb-3"
                v-for="(item, index) of TodayKatamars.slice(0, 3)"
                :key="index"
              >
                <!-- <i :class="feature.icon" class="mr-3"></i> -->
                # {{ item.Name }}
              </li>
            </ul>
            <div class="col-12 mt-3">
              <button class="rounded-pill text-white btn btn-primary">
                {{ $t("ViewMore") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    TodaySinksar() {
      return this.$store.state.HomeList.TodaySinksar;
    },
    TodayKatamars() {
      return this.$store.state.HomeList.TodayKatamars;
    },
  },
  data() {
    return {};
  },
  methods: {
    GetDetails() {
      this.$router.push("/SinksarAndKatamarsDetails");
    },
  },
  created() {},
};
</script>
